<template>
	<li :class="{ active: item.active, finished: item.finished }" @click="$emit('click')">
		<span class="item-container">
			<span>
				<!-- If label is more than 2 words, show just the first one -->
				{{ labelWords.length > 2 ? labelWords[0] : item.label }}
			</span>

            <img v-if="item.icon" :src="item.icon" :alt="item.label">
		</span>
	</li>
</template>

<script>
	export default {
		name: "SideNavItem",
		props: [
			"item"
		],
		computed: {
			labelWords() {
				return this.item.label.split(" ");
			}
		}
	}
</script>
